import { format } from 'date-fns';

const getDateFormated = (
  mes: number,
  ano: number,
): { dtaIni: string; dtaFim: string } => {
  const dataInicial = new Date(ano, mes - 1, 1);
  const dataFinal = new Date(ano, mes, 0);

  const dtaIni = format(dataInicial, 'yyyy-MM-dd');
  const dtaFim = format(dataFinal, 'yyyy-MM-dd');

  return { dtaIni, dtaFim };
};

export default getDateFormated;
